import { useState, useEffect } from 'react';
import { getUsers, updateUser, deleteUser, exportUsers } from '../services/adminService';
import { USER_STATUS, SORT_OPTIONS, SORT_ORDER, EXPORT_FORMATS } from '../constant/constant';

export const useUsers = (params = {}) => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    page = 1,
    limit = 10,
    search = '',
    status = USER_STATUS.ALL,
    sortBy = SORT_OPTIONS.CREATED_AT,
    sortOrder = SORT_ORDER.DESC
  } = params;

  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getUsers({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder
      });
      setUsers(data.users || []);
      setPagination(data.pagination || {});
    } catch (err) {
      setError(err.message);
      console.error('Failed to fetch users:', err);
      setUsers([]);
      setPagination({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, limit, search, status, sortBy, sortOrder]);

  const refetch = async () => {
    await fetchUsers();
  };

  const handleUpdateUser = async (userId, userData) => {
    try {
      await updateUser(userId, userData);
      // Refetch users after update
      await refetch();
      return { success: true };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      await deleteUser(userId);
      // Refetch users after deletion
      await refetch();
      return { success: true };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  const handleExportUsers = async (format = EXPORT_FORMATS.CSV) => {
    try {
      await exportUsers(format, status);
      return { success: true };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  return {
    users,
    pagination,
    loading,
    error,
    refetch,
    updateUser: handleUpdateUser,
    deleteUser: handleDeleteUser,
    exportUsers: handleExportUsers
  };
};
